import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { a as extractElementsFromSlot } from './slot-utils.js';
import { d as defineCustomElement$2 } from './icon.js';

const searchFilterCss = ".search-bar{display:flex;font:var(--tt-font-medium);column-gap:var(--tt-spacing-md);align-items:center;padding-bottom:var(--tt-spacing-xs);border-bottom:1px solid var(--tt-color-gray-200)}.search-filter-input{font:var(--tt-font-standard);display:flex;column-gap:var(--tt-spacing-2xs);flex:1}.search-filter-input tt-icon{font-size:var(--tt-font-size-lg)}.search-filter-input input{display:inline-flex;background:transparent;flex:1;border:0;color:var(--tt-color-gray-800)}.search-filter-input input:focus{outline:none}.search-filter-options{display:flex}::slotted(tt-select){display:inline-flex;--select-background-color:transparent;--select-hover-background-color:transparent;--select-padding-block:1px;--select-font-size:var(--tt-font-size-xs)}";

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
const TtSearchFilter$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.ttChange = createEvent(this, "tt-change", 7);
    this.ttDebouncedChange = createEvent(this, "tt-debounced-change", 7);
    this.filterElements = [];
    this.emitDebouncedEvent = debounce(() => {
      var _a;
      return this.ttDebouncedChange.emit({
        search: (_a = this.searchInput) === null || _a === void 0 ? void 0 : _a.value,
        filters: this.readFilterValues(),
      });
    });
    this.value = '';
    this.placeholder = 'Search';
    this.autofocus = false;
  }
  /** Sets focus on the input. */
  async setFocus(options) {
    this.searchInput.focus(options);
  }
  /** Removes focus from the input. */
  async removeFocus() {
    this.searchInput.blur();
  }
  /** Gets the currently selected values from the filters. */
  async getFilterValues() {
    return this.readFilterValues();
  }
  connectedCallback() {
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.readFilterValues = this.readFilterValues.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSlotChange = this.handleSlotChange.bind(this);
    this.emitEvent = this.emitEvent.bind(this);
  }
  componentDidLoad() {
    if (this.autofocus) {
      this.setFocus();
    }
  }
  handleFilterChange(selectEvent) {
    selectEvent.stopPropagation();
    this.emitEvent();
  }
  readFilterValues() {
    var _a;
    const ret = this.filterElements.reduce((selections, filter) => {
      if (filter.name !== undefined && filter.value !== undefined) {
        return Object.assign(Object.assign({}, selections), { [filter.name]: filter.value });
      }
      return selections;
    }, {});
    ret['search'] = (_a = this.searchInput) === null || _a === void 0 ? void 0 : _a.value;
    return ret;
  }
  emitEvent() {
    var _a;
    this.ttChange.emit({
      search: (_a = this.searchInput) === null || _a === void 0 ? void 0 : _a.value,
      filters: this.readFilterValues(),
    });
    this.emitDebouncedEvent();
  }
  handleKeyDown(event) {
    if (event.key !== 'Enter') {
      event.stopPropagation();
    }
  }
  handleSlotChange(event) {
    this.filterElements = extractElementsFromSlot(event.target, ['tt-select', 'tt-filter']).flat();
  }
  render() {
    return (h("search", { role: "search" // Needed because lack of support for search tag @see: https://caniuse.com/mdn-html_elements_search
      ,
      class: "search-bar" }, h("div", { class: "search-filter-input" }, h("tt-icon", { name: "search", library: "23", "aria-hidden": "true" }), h("input", { ref: (si) => {
        if (si)
          this.searchInput = si;
      }, type: "search", placeholder: this.placeholder, value: this.value, autoFocus: this.autofocus, onChange: this.emitEvent, onInput: this.emitEvent, onKeyDown: this.handleKeyDown, onKeyPress: this.handleKeyDown })), h("div", { class: "search-filter-options", "onTt-change": this.handleFilterChange, "aria-label": "Search filters" }, h("slot", { onSlotchange: this.handleSlotChange }))));
  }
  static get style() { return searchFilterCss; }
}, [1, "tt-search-filter", {
    "value": [513],
    "placeholder": [513],
    "autofocus": [4],
    "setFocus": [64],
    "removeFocus": [64],
    "getFilterValues": [64]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-search-filter", "tt-icon"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-search-filter":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, TtSearchFilter$1);
      }
      break;
    case "tt-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtSearchFilter = TtSearchFilter$1;
const defineCustomElement = defineCustomElement$1;

export { TtSearchFilter, defineCustomElement };
